import { Button } from "../ui/button";

interface SettingsHeaderProps {
  title: string;
  buttonAction?: () => void;
  buttonLabel?: string;
  buttonDisabled?: boolean;
}

export const SettingsHeader = ({
  title,
  buttonAction,
  buttonLabel,
  buttonDisabled,
}: SettingsHeaderProps) => {
  return (
    <div className="flex w-full flex-row items-center justify-between gap-4 md:py-6">
      <h1 className="text-2xl hidden md:block font-bold">{title}</h1>
      {buttonAction && buttonLabel && (
        <Button
          disabled={buttonDisabled}
          className="w-full md:w-auto"
          onClick={buttonAction}
          variant="success"
        >
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};
